import { createContext } from 'react';

import type { CommunityPost } from '~/interfaces/community';

export interface OpenPostComposerOptions {
  defaultSpaceSlug?: string;
  quotedPost?: CommunityPost;
  /** Opens the composer in edit mode with this post's title and body. */
  editPost?: CommunityPost;
}

export interface PostComposerContextType {
  openComposer: (options?: OpenPostComposerOptions) => void;
}

export const PostComposerContext = createContext<PostComposerContextType | null>(null);
